import styled from 'styled-components'
import theme from 'styles/theme'
import { InputDropdown } from '../FormDropdown/FormDropdown.style'

export const Input = styled(InputDropdown)`
  width: 100% !important;
`
export const DatepickerWrapper = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }
`
export const Wrapper = styled.div`
  margin: ${theme.space[6]} 0;

  ${theme.mediaQueries.small} {
    margin: ${theme.space[2]} 0;
  }
`
